import { api } from "./api"

export const GET_ALL_APNS = async () => {
    const {data} = await api.get(`/apns`)
    return data;
}

export const DELETE_APN = async (agencyId) => {
    const {data} = await api.delete(`/apns/${agencyId}`)
    return data;
}

export const SAVE_APN = async (params) => {
    const {data} = await api.post(`/apns`, params)
    return data;
}
